module.exports = __webpack_public_path__ + "290d00405af746847d6da0556f36bfce.png";